/**
 * @generated SignedSource<<cee1146957ddfd26792d9071f4a42540>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateInstructorImplInput = {
  clientMutationId?: string | null | undefined;
  data: InstructorImplInput;
  id: string;
};
export type InstructorImplInput = {
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  location?: string | null | undefined;
  name: string;
  portraitFileRef?: string | null | undefined;
  signatureFileRef?: string | null | undefined;
  title?: string | null | undefined;
};
export type EditInstructorScreen_UpdateMutation$variables = {
  input: UpdateInstructorImplInput;
};
export type EditInstructorScreen_UpdateMutation$data = {
  readonly Admin: {
    readonly Instructor: {
      readonly updateInstructorImpl: {
        readonly data: {
          readonly node: {
            readonly id: string;
            readonly name: string;
            readonly superId: string;
            readonly " $fragmentSpreads": FragmentRefs<"EditInstructorScreen_InstructorFragment">;
          };
        };
      } | null | undefined;
    };
  };
};
export type EditInstructorScreen_UpdateMutation = {
  response: EditInstructorScreen_UpdateMutation$data;
  variables: EditInstructorScreen_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "superId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditInstructorScreen_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InstructorAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Instructor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdateInstructorImplPayload",
                "kind": "LinkedField",
                "name": "updateInstructorImpl",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstructorImplEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstructorImpl",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "EditInstructorScreen_InstructorFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditInstructorScreen_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InstructorAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Instructor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdateInstructorImplPayload",
                "kind": "LinkedField",
                "name": "updateInstructorImpl",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstructorImplEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstructorImpl",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "location",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "portraitFile",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "signatureFile",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f33161cd312bcdcc67acc36d55e0e3e",
    "id": null,
    "metadata": {},
    "name": "EditInstructorScreen_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EditInstructorScreen_UpdateMutation(\n  $input: UpdateInstructorImplInput!\n) {\n  Admin {\n    Instructor {\n      updateInstructorImpl(input: $input) {\n        data {\n          node {\n            id\n            superId\n            name\n            ...EditInstructorScreen_InstructorFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditInstructorScreen_InstructorFragment on InstructorImpl {\n  id\n  superId\n  name\n  title\n  description\n  location\n  portraitFile {\n    id\n    url\n  }\n  signatureFile {\n    id\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "76a466efb49be377a6204b1f89a1ea13";

export default node;
